/**
 * @fileoverview Barrel exports for the character-continuity-checker-v2 agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  FindingSchema,
  IssueSeverityEnum,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, characterContinuityCheckerV2AgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
